/*
 * @Author: Ashley.Liu
 * @Date: 2022-05-11 13:27:50
 * @LastEditTime: 2022-05-31 16:37:35
 * @Description: desc
 */
import Vue from 'vue'
const vm = new Vue()

export const statusCode = {
  0: 'Request timeout!',
  401: 'Unauthorized!',
  403: 'Access Denied!',
  404: 'Resource was not found.',
  500: 'Server Error, Please try again later!',
  501: 'Request method is not supported by the server and cannot be processed',
  502: 'Server Error, Please try again later!',
  503: 'Server Error, Please try again later!',
  505: 'Server does not support the HTTP protocol version.'
}

export const handleErrorMsg = (
  errorResponse,
  showErrorFn
) => {
  const { status = 0, data = {} } = errorResponse || {}
  let errMesasage = data.message
  if (errMesasage && errMesasage.indexOf('Exception:') !== -1) {
    errMesasage = errMesasage.slice(errMesasage.indexOf('Exception:') + 10, errMesasage.length)
  }
  errMesasage = errMesasage || statusCode[status] || 'Network error!'
  showErrorFn
    ? showErrorFn(errMesasage)
    : (errMesasage && vm.$message({
      message: errMesasage,
      type: 'error',
      duration: 5 * 1000
    }))
}
